jQuery($ => {


    if ($('.o-featured-products-block--hide-products')[0]) {
        $('.o-featured-products-block__show-all').click(function () {
            const $section = $(this).closest('section');

            $section.removeClass('o-featured-products-block--hide-products');
        });
    }
});